import { render, staticRenderFns } from "./BSubmitButton.vue?vue&type=template&id=0f0a0536"
import script from "./BSubmitButton.vue?vue&type=script&lang=ts"
export * from "./BSubmitButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports